(function () {
  'use strict';

  function registerEntityController($scope, $log, $timeout, $rootScope,
    $location, $window, $cookies, $filter,
    showProgressHeader, STATES_LIST, registrationDataService, notifyService) {

    var vm = this;
    vm.entityType = $filter('underscoresToCamelCase')($rootScope.$state.params.entityType);
    vm.showProgressHeader = showProgressHeader;
    vm.statesList = STATES_LIST;

    vm.model = {
      EntityType: vm.entityType,
      ReferralCampaign: $cookies.get('referralCampaign'),
      ReferralToken: $cookies.get('referralToken')
    };

    $timeout(function () {
      var iframe = document.getElementById("termsOfService").contentWindow;
      $(iframe).scroll(function () {
          if ($(iframe).scrollTop()*1.0 / $(iframe.document).innerHeight() > 0.9) {
              vm.canCheckBox = true;
              $scope.$apply();
          }
      });
    }, 1000);

    vm.errors = [];
    vm.submit = function() {
      vm.hideButtons = true;
      // if (!vm.model.CompanyDetails.State) {
      //   vm.errors = ["State is missing"];
      //   vm.hideButtons = false;
      //   return;
      // }

      if (vm.model.AccountType === "PlatformEntity" && !vm.model.EditableEntityType) {
        vm.errors = ["EntityType is missing"];
        vm.hideButtons = false;
        return;
      }

      registrationDataService.registerEntity(vm.model).then(
        function (result) {
          if (result.Errors && result.Errors.length > 0) {
            vm.errors = result.Errors;
            vm.hideButtons = false;
          }
          else {
            vm.hideButtons = true;
            vm.errors = [];
            notifyService.notify('Your account has been created. You are being logged in.');

            // remove cookies
            if ($cookies.get('referralCampaign')) {
              $cookies.remove('referralCampaign');
            }

            if ($cookies.get('referralToken')) {
              $cookies.remove('referralToken');
            }

            $timeout(function () {
              $('#submitAfterRegisteringForm').submit();
            }, 2000);
          }
        }
      )
    }
  }

  registerEntityController.$inject = [
    '$scope', '$log', '$timeout', '$rootScope',
    '$location', '$window', '$cookies', '$filter',
    'showProgressHeader', 'STATES_LIST', 'registrationDataService', 'notifyService'
  ];

  angular.module('ecap.registration').controller('registerEntityController', registerEntityController);
})();